export type LogCategory = 'missingTranslation' | 'cityMapResolver' | 'homePageComponent' | 'listingsService' | 'httpRequests';

export type LogLevel = 'info' | 'warn' | 'fail' | 'dbug';

const consoleInfo = console.info.bind(console);
const consoleWarn = console.warn.bind(console);
const consoleError = console.error.bind(console);

export abstract class LoggerService {
    logInfo(category: LogCategory, ...args: any[]) {
        this.logIfEnabled(consoleInfo, 'info', category, args);
    }
    logWarn(category: LogCategory, ...args: any[]) {
        this.logIfEnabled(consoleWarn, 'warn', category, args);
    }
    logError(category: LogCategory, ...args: any[]) {
        this.logIfEnabled(consoleError, 'fail', category, args);
    }
    logDebug(category: LogCategory, ...args: any[]) {
        this.logIfEnabled(consoleInfo, 'dbug', category, args);
    }

    private logIfEnabled(func: Function, level: LogLevel, category: LogCategory, ...args: any[]) {
        if (!this.isEnabled(category, level)) {
            return;
        }

        const msg = this.buildLogMessage(level, category, args);
        func(msg);
    }

    protected abstract isEnabled(category: LogCategory, level: LogLevel);

    protected buildLogMessage(level: LogLevel, category: LogCategory, ...args: any[]): string {

        return [new Date().toISOString()].concat(Array.prototype.slice.call(arguments, 0)).join(' ');
    }
}
